<template>
  <div class="CouponList">
    <section-header  ja="クーポン" en="Coupon">
      <img src="@/assets/Png/title/coupon.png">
    </section-header>
    <div class="description">セガのプリクラ機で使えるチケット・クーポンを確認できるよ！</div>
    <div class="descriptionBox">
      <div class="toggleArea">
        <span>クーポンの使用</span>
        <button
          @click="setCouponOnoff()"
          class="toggleButton"
          :class="{'on': isCouponOn}"
          :disabled="prevention" />
        <button
          @click="hasCouponOnoff = true"
          class="questionButton" />
      </div>
      <div class="infoLink">
        <div class="link-text" @click="onHistory">チケット・クーポン履歴</div>
        <div class="link-text" @click="onHelp">クーポンの使い方</div>
      </div>
    </div>
    <div v-if="!isCouponOn" class="description warning">
      現在クーポン使用の設定が「OFF」のためプリクラ機でクーポンは使用できません。<br>
      使用するにはクーポンの使用を「ON」に切り替えてください。
    </div>
    <v-window v-model="indexOfPage" v-if="pages && pages.length">
      <v-window-item v-for="(page, col) in pages" :key="col">
        <div
          class="coupon-area"
          v-for="(coupon, row) in page"
          :key="row"
          @click="onCoupon(col, row)">
          <coupon
            class="coupon"
            :image-path="coupon.imagePath"
            :advertise = "coupon.advertise"
            :start-time="coupon.startTime"
            :end-time="coupon.endTime"
            :use-num="coupon.useNum"
            :description="coupon.description"
            :kind="coupon.kind"
          ></coupon>
        </div>
      </v-window-item>
    </v-window>
    <template v-else>
      <text-box title="今使えるクーポンを持ってないよ" />
    </template>
    <pager
      v-if="pages.length > 1"
      v-model="indexOfPage"
      :count="pages.length" />
    
    <Dialog v-if="hasTappedCoupon">
      <div v-if="tappedCoupon !== null">
        <div class="imgArea" :style="'background-image: url(' + tappedCoupon.imagePath + ')'"></div>
        <div class="dialog-kind">{{getKind(tappedCoupon.kind)}}</div>
        <div class="dialog-data">
          <div>使用期限 : {{getLimit(tappedCoupon.startTime, tappedCoupon.endTime)}}</div>
          <div>{{ tappedCoupon.useNum }}</div>
        </div>
        <div class="dialog-text">
          <div>{{tappedCoupon.description}}</div>
        </div>
      </div>
      <button class="closeBtn" @click="hasTappedCoupon = false" />
      <normal-btn v-if="tappedCoupon.kind === 5" @click="onAboutWeb05()">プリもっとって？</normal-btn>
      <normal-btn v-else @click="onLocationMap()">使える店舗を探す</normal-btn>
    </Dialog>
    <Dialog v-if="hasReceiveCoupon">
      <template v-if="receiveCoupon && receiveCoupon.length">
        <div class="dialog-title">クーポンGET！</div>
        <div v-for="(item, index) in receiveCoupon" :key="index" class="coupon-wrapper">
          <coupon
            class="coupon"
            :image-path="item.imagePath"
            :advertise = "item.advertise"
            :start-time="item.startTime"
            :end-time="item.endTime"
            :use-num="item.useNum"
            :description="item.description"
            :kind="item.kind"
          ></coupon>
        </div>
      </template>
      <template v-else>
        <div class="dialog-text">獲得できるクーポンがありません</div>
        <div class="dialog-text">
          プリもっとで使えるクーポンはアプリ版のプリクラONから獲得できます<br>
          ※プリもっとで使えるクーポンが配布されている場合に限ります
        </div>
      </template>
      <normal-btn @click="hasReceiveCoupon = false">閉じる</normal-btn>
    </Dialog>
    <Dialog v-if="hasCouponOnoff">
      <div class="coupon-wrapper">
        <div class="dialog-text">この設定を「OFF」にすると プリクラ機でクーポンは使用できなくなり、 クーポンの選択画面をスキップします。</div>
        <div class="dialog-text">使用するには「ON」に切り替えてください。</div>
      </div>
      <button class="closeBtn" @click="hasCouponOnoff = false"></button>
    </Dialog>
  </div>
</template>

<script>
import Coupon from "../components/Coupon"
import Pager from "../components/Pager"
import SectionHeader from "../components/SectionHeader"
import Dialog from '../components/Dialog'
import Protobuf from '../mixins/protobuf'
import Screen from '../mixins/screen'
import NormalBtn from '../components/NormalBtn'
import TextBox from '../components/TextBox'
import { splitArray, ymd } from "../assets/js/util"

const pb = require('../assets/js/kumaproto').kuma.jp.protobuf.web
const MAX_ROW = 10

export default {
  name: "CouponList",
  components: {
    Coupon,
    Pager,
    SectionHeader,
    Dialog,
    NormalBtn,
    TextBox
  },
  mixins: [Protobuf, Screen],
  data() {
    return {
      indexOfPage: 0,
      coupons: [],
      hasTappedCoupon: false,
      hasReceiveCoupon: false,
      hasCouponOnoff: false,
      tappedCoupon: null,
      receiveCoupon: [],
      isCouponOn: true,
      prevention: false
    }
  },
  computed: {
    pages() {
      return splitArray(this.coupons, MAX_ROW)
    }
  },
  mounted() {
    sessionStorage.setItem('prevPage', '/CouponList');
    this.getCouponData();
    this.getCouponOnoff();
  },
  methods: {
    getCouponData() {
      const cmdNo = pb.CouponListReq.CommandNo.COMMAND_NO
      const message = pb.CouponListReq.create()
      const encoded = pb.CouponListReq.encode(message).finish()
      this.post(cmdNo, encoded)
      .then(decoded => {
        if (decoded === undefined || decoded.coupons === undefined) {
          this.$_error('Error', { title: 'クーポン', statusCode: 470 })
          return
        }
        this.coupons = decoded.coupons
      })
      .catch(() => {
        this.$_error('Error', {
          title: 'クーポン一覧',
          statusCode: 470
        })
      })
    },
    getCouponOnoff() {
      const cmdNo = pb.CouponSettingReq.CommandNo.COMMAND_NO
      const message = pb.CouponSettingReq.create({
        couponDisplaySetting: -1
      })
      const encoded = pb.CouponSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          decoded.couponDisplaySetting ? this.isCouponOn = true : this.isCouponOn = false
        })
        .catch(() => {
          this.$_error('Error', { title: 'クーポン', statusCode: 100 })
        })
    },
    toymd(time) {
      if(time === 0) return 'なし'
      const _ymd = ymd(time)
      return `${_ymd[0]}/${_ymd[1]}/${_ymd[2]}`
    },
    struseNum(useNum) {
      if(useNum === 0) return '回数制限なし'
      return `残り${ useNum }枚`
    },
    indexOfCoupons(col, row) {
      return col * MAX_ROW + row
    },
    getLimit(start, end) {
      // endが2099/1/1以降になっているものは無期限表示にする
      if(4070876400 > end) {
        return this.toymd(start) + ' ~ ' + this.toymd(end);
      } else {
        return '無期限'
      }
    },
    onCoupon(col, row) {
      const coupon = this.coupons[this.indexOfCoupons(col, row)]
      const cmdNo = pb.CouponReq.CommandNo.COMMAND_NO
      const message = pb.CouponReq.create({
        couponId: coupon.couponId
      })
      const encoded = pb.CouponReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.CouponResp.Status.SUCCESS) {
            this.tappedCoupon = {
              name: coupon.couponName,
              useNum: this.struseNum(coupon.useNum),
              advertise: coupon.advertise,
              startTime: coupon.startTime,
              endTime: coupon.endTime,
              description: coupon.description,
              kind: coupon.kind,
              imagePath: process.env.VUE_APP_STATIC_CONTENT_SERVER_URL + coupon.imagePath,
            }
            this.hasTappedCoupon = true
          } else {
            this.$_error('Error', { title: 'クーポン', statusCode: 470 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'クーポン', statusCode: 100 })
        })
    },
    onHistory() {
      this.$router.push('/couponHistory')
    },
    onHelp() {
      this.$router.push('/couponHelp')
    },
    getCoupon() {
      const cmdNo = pb.BonusReq.CommandNo.COMMAND_NO
      const message = pb.BonusReq.create()
      const encoded = pb.BonusReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.BonusResp.Status.SUCCESS) {
            this.receiveCoupon = decoded.items;
            this.hasReceiveCoupon = true;
            this.getCouponData();
          } else {
            this.$_error('Error', { title: 'クーポン', statusCode: 470 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'クーポン', statusCode: 100 })
        })
    },
    getKind(kind) {
      switch(kind) {
        case 1: return '￥100円引き';
        case 2: return '￥200円引き';
        case 3: return 'プレイ無料';
        case 4: return '';
        case 5: return 'プリもっと獲得';
        case 6: return 'ALL画像ダウンロード';
        default: return null;
      }
    },
    onAboutWeb05() {
      this.$router.push("/AboutWeb05")
    },
    onLocationMap() {
      window.open("https://puri.sega.jp/location-map/", "_blank")
    },
    setCouponOnoff() {
      this.isCouponOn ? this.isCouponOn = false : this.isCouponOn = true

      const cmdNo = pb.CouponSettingReq.CommandNo.COMMAND_NO
      const message = pb.CouponSettingReq.create({
        couponDisplaySetting: this.isCouponOn ? 1 : 0
      })
      const encoded = pb.CouponSettingReq.encode(message).finish()
      this.post(cmdNo, encoded)
        .then(decoded => {
          if (decoded.status === pb.CouponSettingResp.Status.SUCCESS) {
            console.log('SUCCESS')
            // 連打防止
            if (this.prevention) return;
            this.prevention = true;

            // 5秒後、押せるようにする
            setTimeout(function () {
                this.prevention = false;
            }.bind(this), 5000);
          } else {
            this.$_error('Error', { title: 'クーポン', statusCode: 470 })
          }
        })
        .catch(() => {
          this.$_error('Error', { title: 'クーポン', statusCode: 100 })
        })
    }
  },
  watch: {
    hasTappedCoupon(v) {
      if (!v) {
        this.tappedCoupon = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.descriptionBox {
  display: flex;
  justify-content: space-between;
}
.toggleArea {
  display: flex;
  align-items: center;
  font-size: 10px;
  color: #373737;
  padding-left: 30px;
  .toggleButton {
    width: 44px;
    height: 20px;
    margin-left: 5px;
    background: #fff;
    position: relative;
    display: inline-block;
    border-radius: 46px;
    border: 1px solid #575757;
    transition: .2s;
    box-sizing: border-box;
    outline: none;
    &:after {
      content: '';
      position: absolute;
      width: 14px;
      height: 14px;
      border: 1px solid #575757;
      border-radius: 100%;
      left: 2px;
      top: 2px;
      z-index: 2;
      background: #fff;
      transition: .2s;
    }
    &.on {
      background-color: #F63C5B;
      &:after{ left: 26px; }
    }
  }

  .questionButton {
    width: 20px;
    height: 20px;
    margin-left: 5px;
    background-color: #fff;
    background-image: url(../assets/Png/Common/ic_question.png);
    background-size: contain;
    border-radius: 50%;
  }
}
.infoLink {
  margin-top: 20px;
  padding: 0 30px;
  cursor: pointer;
  & > div {
  margin-top: 15px;
  padding-right: 30px;
  text-align: right;
  font-size: 10px;
  color: #F63C5B;
  background-image:
    linear-gradient(to left, #F63C5B, #F63C5B),
    linear-gradient(45deg, transparent 47%, #F63C5B 49%, #F63C5B 51%, transparent 53%);
  background-repeat: no-repeat;
  background-size: 24px 1px, 8px 8px;
  background-position: right 70%, right 40%;
  }
}
.dialog {
  .coupon-wrapper { margin-top: 50px; }
  .dialog-title {
    text-align: center;
    font-weight: bold;
    color: #F63C5B;
  }
  .imgArea {
    margin-top: 20px;
    width: 315px;
    height: 177px;
    background-size: cover;
    background-position: center;
  }
  .dialog-kind {
    margin-top: 10px;
    font-size: 12px;
    color: #F63C5B;
  }
  .dialog-data {
    margin-top: 5px;
    font-size: 12px;
    color: #DA2240;
  }
  .dialog-text {
    margin-top: 10px;
    font-size: 12px;
    color: #373737;
  }
  .locationLink {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #373737;
    button {
      font-size: 10px;
      font-weight: bold;
      & > img {
        width: 60px;
        height: auto;
      }
    }
  }
  .NormalBtn {
    margin: 20px 0 0 0;
     & > a {
       text-decoration: none;
       display: block;
       color: #fff;
     }
  }
}

.description {
  margin: 30px 30px 0;
  font-size: 12px;
  color: #373737;
  &.right { text-align: right; }
  &.warning { color: #F63C5B; }
}
.coupon-area { margin: 20px 30px; }
.dialog-actions {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  position: absolute;
  bottom: 0;
  width: 100%;
}
</style>
